import type { ReactNode } from "react";
import { useMemo } from "react";
import { Box } from "@mui/material";
import CheckCircleIconBase from "@mui/icons-material/CheckCircle";
import ErrorIconBase from "@mui/icons-material/Error";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import JoinCampaignLocationName from "./JoinCampaignLocationName";

const DisabledRadioButtonUncheckedIcon = RadioButtonUncheckedIcon as any;
const ErrorIcon = ErrorIconBase as any;
const CheckCircleIcon = CheckCircleIconBase as any;

type JoinCampaignLocationHeaderProps = {
  locationName?: ReactNode;
  isFullyFilled?: boolean;
  otherDataToDisplay?: ReactNode;
  locationStatusNote?: ReactNode;
};

function JoinCampaignLocationHeader({
  locationName,
  isFullyFilled,
  otherDataToDisplay,
  locationStatusNote,
}: JoinCampaignLocationHeaderProps) {
  const icon = useMemo(() => {
    let icn = (
      <DisabledRadioButtonUncheckedIcon
        color="disabled"
        className="mr-1 d-none"
        disabled
      />
    );

    icn = <ErrorIcon color="error" className="mr-1" title="Partially filled" />;

    if (isFullyFilled) {
      icn = (
        <CheckCircleIcon
          color="primary"
          className="mr-1"
          title="Fully filled"
        />
      );
    }

    return icn;
  }, [isFullyFilled]);

  if (locationStatusNote) {
    return (
      <div onFocus={(event) => event.stopPropagation()}>
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <Box component="span" sx={{ flexShrink: 0, mt: "5px" }}>
            {icon}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <JoinCampaignLocationName>
              <Box
                component="span"
                sx={{
                  width: { xs: "85%", sm: "auto" },
                  display: "inline-flex",
                }}
              >
                {locationName}
              </Box>
            </JoinCampaignLocationName>
            <Box sx={{ mt: 0.5 }}>{locationStatusNote}</Box>
          </Box>
        </Box>
        {otherDataToDisplay || null}
      </div>
    );
  }

  return (
    <div onFocus={(event) => event.stopPropagation()}>
      <JoinCampaignLocationName>
        {icon}{" "}
        <Box
          component="span"
          sx={{ width: { xs: "85%", sm: "auto" }, display: "inline-flex" }}
        >
          {locationName}
        </Box>
      </JoinCampaignLocationName>
      {otherDataToDisplay || null}
    </div>
  );
}

export default JoinCampaignLocationHeader;
